// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2571":"4101e2df","9707":"74a30f33"}[chunkId] + ".chunk.css";
};